import { AnimatedSprite } from "appworks/graphics/animation/animated-sprite";
import { ButtonElement } from "appworks/graphics/elements/button-element";
import { SmartShape } from "appworks/graphics/elements/smart-shape";
import { Layers } from "appworks/graphics/layers/layers";
import { Scene } from "appworks/graphics/layers/scene";
import { DualPosition } from "appworks/graphics/pixi/dual-position";
import { SpineContainer } from "appworks/graphics/pixi/spine-container";
import { Sprite } from "appworks/graphics/pixi/sprite";
import { Text } from "appworks/graphics/pixi/text";
import { SoundNames } from "sounds-enum";

class GameLayers {
    public Alerts: Layers & {
        scene: {
             error: Scene & {
                contents: {
                    continue?: ButtonElement
                    modal_bg?: Sprite
                    cover?: SmartShape
                    body?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    continue?: ButtonElement
                    modal_bg?: Sprite
                    cover?: SmartShape
                    body?: Text
                    no?: ButtonElement
                };
            };
             info: Scene & {
                contents: {
                    continue?: ButtonElement
                    modal_bg?: Sprite
                    cover?: SmartShape
                    body?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             load_sounds: Scene & {
                contents: {
                    modal_bg?: Sprite
                    cover?: SmartShape
                    body?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             yes_no: Scene & {
                contents: {
                    no?: ButtonElement
                    continue?: ButtonElement
                    modal_bg?: Sprite
                    cover?: SmartShape
                    body?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
        };
    };
    public Background: Layers & {
        scene: {
             default: Scene & {
                contents: {
                    bg_flame?: AnimatedSprite
                    Portrait_Background?: Sprite
                    Landscape_Background?: Sprite
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    bg_flame?: AnimatedSprite
                    Portrait_Background?: Sprite
                    Landscape_Background?: Sprite
                };
            };
        };
    };
    public Banners: Layers & {
        scene: {
             default: Scene & {
                contents: {
                    logo_anim?: AnimatedSprite
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    logo_anim?: AnimatedSprite
                };
            };
        };
    };
    public BetBar: Layers & {
        scene: {
             base: Scene & {
                contents: {
                    ui_bet_button?: ButtonElement
                    win_box_landscape?: Sprite
                    win_box_portrait?: Sprite
                    bonus_win_label?: Text
                    balance_label?: Text
                    bet_label?: Text
                    balance_currency_label?: Text
                    total_bet_label?: Text
                    winlabel_landscape?: Text
                    total_win_currency_value_landscape?: Text
                    total_stake?: Text
                    total_in_credits?: Text
                    balance_currency_value?: Text
                    winlabel_portrait?: Text
                    total_win_currency_value_portrait?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    ui_bet_button?: ButtonElement
                    win_box_landscape?: Sprite
                    win_box_portrait?: Sprite
                    bonus_win_label?: Text
                    balance_label?: Text
                    bet_label?: Text
                    balance_currency_label?: Text
                    total_bet_label?: Text
                    winlabel_landscape?: Text
                    total_win_currency_value_landscape?: Text
                    total_stake?: Text
                    total_in_credits?: Text
                    balance_currency_value?: Text
                    winlabel_portrait?: Text
                    total_win_currency_value_portrait?: Text
                };
            };
             base_currency: Scene & {
                contents: {
                    ui_bet_button?: ButtonElement
                    win_box_landscape?: Sprite
                    win_box_portrait?: Sprite
                    bonus_win_label?: Text
                    balance_label?: Text
                    bet_label?: Text
                    balance_currency_label?: Text
                    total_bet_label?: Text
                    winlabel_landscape?: Text
                    total_win_currency_value_landscape?: Text
                    total_stake?: Text
                    total_in_credits?: Text
                    balance_currency_value?: Text
                    winlabel_portrait?: Text
                    total_win_currency_value_portrait?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             freespins: Scene & {
                contents: {
                    ui_bet_button?: ButtonElement
                    win_box_landscape?: Sprite
                    win_box_portrait?: Sprite
                    bonus_win_label?: Text
                    balance_label?: Text
                    bet_label?: Text
                    balance_currency_label?: Text
                    total_bet_label?: Text
                    winlabel_landscape?: Text
                    total_win_currency_value_landscape?: Text
                    total_stake?: Text
                    total_in_credits?: Text
                    balance_currency_value?: Text
                    winlabel_portrait?: Text
                    total_win_currency_value_portrait?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             freespins_currency: Scene & {
                contents: {
                    ui_bet_button?: ButtonElement
                    win_box_landscape?: Sprite
                    win_box_portrait?: Sprite
                    bonus_win_label?: Text
                    balance_label?: Text
                    bet_label?: Text
                    balance_currency_label?: Text
                    total_bet_label?: Text
                    winlabel_landscape?: Text
                    total_win_currency_value_landscape?: Text
                    total_stake?: Text
                    total_in_credits?: Text
                    balance_currency_value?: Text
                    winlabel_portrait?: Text
                    total_win_currency_value_portrait?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
        };
    };
    public BigWinEmitter: Layers & {
        scene: {
             bigwin: Scene & {
                contents: {
                    bigWinBackground?: Sprite
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    bigWinBackground?: Sprite
                };
            };
        };
    };
    public BigWinFirework: Layers & {
        scene: {
             default: Scene & {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                        firework_target?: DualPosition
                        firework_source?: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                        firework_target?: DualPosition
                        firework_source?: DualPosition
                    };
                };
            };
        };
    };
    public BigWinText: Layers & {
        scene: {
             bigwin: Scene & {
                contents: {
                    big_win_label?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    big_win_label?: Text
                };
            };
        };
    };
    public CelebrationContent: Layers & {
        scene: {
             line_0_win: Scene & {
                contents: {
                    line0_dots?: Sprite
                    line0_segment?: Sprite
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    line0_dots?: Sprite
                    line0_segment?: Sprite
                    line1_dots?: Sprite
                    line1_segment?: Sprite
                    line2_dots?: Sprite
                    line2_segment?: Sprite
                    line3_dots?: Sprite
                    line3_segment?: Sprite
                    line4_dots?: Sprite
                    line4_segment?: Sprite
                    line5_dots?: Sprite
                    line5_segment?: Sprite
                    line6_dots?: Sprite
                    line6_segment?: Sprite
                    line7_dots?: Sprite
                    line7_segment?: Sprite
                    line8_dots?: Sprite
                    line8_segment?: Sprite
                };
            };
             line_1_win: Scene & {
                contents: {
                    line1_dots?: Sprite
                    line1_segment?: Sprite
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             line_2_win: Scene & {
                contents: {
                    line2_dots?: Sprite
                    line2_segment?: Sprite
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             line_3_win: Scene & {
                contents: {
                    line3_dots?: Sprite
                    line3_segment?: Sprite
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             line_4_win: Scene & {
                contents: {
                    line4_dots?: Sprite
                    line4_segment?: Sprite
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             line_5_win: Scene & {
                contents: {
                    line5_dots?: Sprite
                    line5_segment?: Sprite
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             line_6_win: Scene & {
                contents: {
                    line6_dots?: Sprite
                    line6_segment?: Sprite
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             line_7_win: Scene & {
                contents: {
                    line7_dots?: Sprite
                    line7_segment?: Sprite
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             line_8_win: Scene & {
                contents: {
                    line8_dots?: Sprite
                    line8_segment?: Sprite
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
        };
    };
    public CelebrationForeground: Layers & {
        scene: {
             bigwincoin: Scene & {
                contents: {
                    bigwin?: SpineContainer
                    bigWin_coin?: Sprite
                    backdrop_overlay?: Sprite
                    total_win_currency_value?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    bigwin?: SpineContainer
                    bigWin_coin?: Sprite
                    backdrop_overlay?: Sprite
                    total_win_currency_value?: Text
                    megawin?: SpineContainer
                    bigWin_gem?: Sprite
                };
            };
             bigwingem: Scene & {
                contents: {
                    megawin?: SpineContainer
                    bigWin_gem?: Sprite
                    backdrop_overlay?: Sprite
                    total_win_currency_value?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
        };
    };
    public Footer: Layers & {
        scene: {
             default: Scene & {
                contents: {
                    value_landscape?: Text
                    value_portrait?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    value_landscape?: Text
                    value_portrait?: Text
                };
            };
        };
    };
    public HamburgerMenu: Layers & {
        scene: {
             base: Scene & {
                contents: {
                    menu_toggle_expand?: ButtonElement
                    menu_toggle_collapse?: ButtonElement
                    sound_toggle_on?: ButtonElement
                    sound_toggle_off?: ButtonElement
                    sound_toggle_loading?: ButtonElement
                    ui_paytable?: ButtonElement
                    ui_settings?: ButtonElement
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    menu_toggle_expand?: ButtonElement
                    menu_toggle_collapse?: ButtonElement
                    sound_toggle_on?: ButtonElement
                    sound_toggle_off?: ButtonElement
                    sound_toggle_loading?: ButtonElement
                    ui_paytable?: ButtonElement
                    ui_settings?: ButtonElement
                };
            };
             base_currency: Scene & {
                contents: {
                    menu_toggle_expand?: ButtonElement
                    menu_toggle_collapse?: ButtonElement
                    sound_toggle_on?: ButtonElement
                    sound_toggle_off?: ButtonElement
                    sound_toggle_loading?: ButtonElement
                    ui_paytable?: ButtonElement
                    ui_settings?: ButtonElement
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             freespins: Scene & {
                contents: {
                    menu_toggle_expand?: ButtonElement
                    menu_toggle_collapse?: ButtonElement
                    sound_toggle_on?: ButtonElement
                    sound_toggle_off?: ButtonElement
                    sound_toggle_loading?: ButtonElement
                    ui_paytable?: ButtonElement
                    ui_settings?: ButtonElement
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             freespins_currency: Scene & {
                contents: {
                    menu_toggle_expand?: ButtonElement
                    menu_toggle_collapse?: ButtonElement
                    sound_toggle_on?: ButtonElement
                    sound_toggle_off?: ButtonElement
                    sound_toggle_loading?: ButtonElement
                    ui_paytable?: ButtonElement
                    ui_settings?: ButtonElement
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
        };
    };
    public Header: Layers & {
        scene: {
             base: Scene & {
                contents: {
                    ags?: Sprite
                    mode?: Text
                    clock?: Text
                    positions: {
                        [key: string]: DualPosition
                        ags_base?: DualPosition
                        ags_bonus?: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                        ags_base?: DualPosition
                        ags_bonus?: DualPosition
                    };
                    ags?: Sprite
                    mode?: Text
                    clock?: Text
                };
            };
        };
    };
    public Jackpots: Layers & {
        scene: {
             default: Scene & {
                contents: {
                    portrait_meter_anim?: AnimatedSprite
                    Portrait_Meters?: Sprite
                    landscape_meter_anim?: AnimatedSprite
                    Landscape_Meters?: Sprite
                    grand_value?: Text
                    major_value?: Text
                    mini_value?: Text
                    minor_value?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    portrait_meter_anim?: AnimatedSprite
                    Portrait_Meters?: Sprite
                    landscape_meter_anim?: AnimatedSprite
                    Landscape_Meters?: Sprite
                    grand_value?: Text
                    major_value?: Text
                    mini_value?: Text
                    minor_value?: Text
                };
            };
        };
    };
    public MatrixBackground: Layers & {
        scene: {
             default: Scene & {
                contents: {
                    reel_backing?: Sprite
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    reel_backing?: Sprite
                };
            };
        };
    };
    public MatrixContent: Layers & {
        scene: {
             default: Scene & {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                        MN?: DualPosition
                        ABC?: DualPosition
                        XYZ?: DualPosition
                        BL?: DualPosition
                        win_over?: DualPosition
                        Z?: DualPosition
                        Y?: DualPosition
                        X?: DualPosition
                        N?: DualPosition
                        M?: DualPosition
                        C?: DualPosition
                        B?: DualPosition
                        A?: DualPosition
                        X_win?: DualPosition
                        Y_win?: DualPosition
                        Z_win?: DualPosition
                        N_win?: DualPosition
                        M_win?: DualPosition
                        A_win?: DualPosition
                        B_win?: DualPosition
                        C_win?: DualPosition
                        static?: DualPosition
                        symbol_x_y?: DualPosition
                        symbol_0_0?: DualPosition
                        symbol_0_1?: DualPosition
                        symbol_0_2?: DualPosition
                        symbol_1_0?: DualPosition
                        symbol_1_1?: DualPosition
                        symbol_1_2?: DualPosition
                        symbol_2_0?: DualPosition
                        symbol_2_1?: DualPosition
                        symbol_2_2?: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                        MN?: DualPosition
                        ABC?: DualPosition
                        XYZ?: DualPosition
                        BL?: DualPosition
                        win_over?: DualPosition
                        Z?: DualPosition
                        Y?: DualPosition
                        X?: DualPosition
                        N?: DualPosition
                        M?: DualPosition
                        C?: DualPosition
                        B?: DualPosition
                        A?: DualPosition
                        X_win?: DualPosition
                        Y_win?: DualPosition
                        Z_win?: DualPosition
                        N_win?: DualPosition
                        M_win?: DualPosition
                        A_win?: DualPosition
                        B_win?: DualPosition
                        C_win?: DualPosition
                        static?: DualPosition
                        symbol_x_y?: DualPosition
                        symbol_0_0?: DualPosition
                        symbol_0_1?: DualPosition
                        symbol_0_2?: DualPosition
                        symbol_1_0?: DualPosition
                        symbol_1_1?: DualPosition
                        symbol_1_2?: DualPosition
                        symbol_2_0?: DualPosition
                        symbol_2_1?: DualPosition
                        symbol_2_2?: DualPosition
                    };
                };
            };
        };
    };
    public MatrixForeground: Layers & {
        scene: {
             default: Scene & {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
        };
    };
    public MenusContent: Layers & {
        scene: {
             autoplay_nonuk: Scene & {
                contents: {
                    autoplay_radio_4?: ButtonElement
                    autoplay_radio_3?: ButtonElement
                    autoplay_radio_2?: ButtonElement
                    autoplay_radio_1?: ButtonElement
                    close?: ButtonElement
                    autoplay_nonUK_bg?: Sprite
                    autoplay_radio_4_label?: Text
                    autoplay_radio_3_label?: Text
                    autoplay_radio_2_label?: Text
                    autoplay_radio_1_label?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    autoplay_radio_4?: ButtonElement
                    autoplay_radio_3?: ButtonElement
                    autoplay_radio_2?: ButtonElement
                    autoplay_radio_1?: ButtonElement
                    close?: ButtonElement
                    autoplay_nonUK_bg?: Sprite
                    autoplay_radio_4_label?: Text
                    autoplay_radio_3_label?: Text
                    autoplay_radio_2_label?: Text
                    autoplay_radio_1_label?: Text
                    bet_amount_slider_down?: ButtonElement
                    bet_amount_slider_up?: ButtonElement
                    bet_amount_slider_handle?: Sprite
                    bet_amount_slider_fill?: Sprite
                    bet_amount_slider_track?: Sprite
                    line_slider_down?: ButtonElement
                    line_slider_up?: ButtonElement
                    line_slider_handle?: Sprite
                    line_slider_fill?: Sprite
                    line_slider_track?: Sprite
                    bet_settings_background?: Sprite
                    detection_area?: Sprite
                    bet_amount_slider_amount?: Text
                    bet_amount_slider_label?: Text
                    line_slider_label?: Text
                    total_stake?: Text
                    total_bet?: Text
                    lines?: Text
                    bet_settings?: Text
                    bet_per_line?: Text
                    help?: ButtonElement
                    ags_deposit?: ButtonElement
                    ags_home?: ButtonElement
                    ags_accounts?: ButtonElement
                    sound_toggle_off?: ButtonElement
                    sound_toggle_on?: ButtonElement
                    sound_toggle_loading?: Sprite
                    left?: SmartShape
                    center?: SmartShape
                    right?: SmartShape
                    cover?: Sprite
                    previous?: ButtonElement
                    next?: ButtonElement
                    page_offset?: ButtonElement
                    page_centre?: ButtonElement
                };
            };
             autoplay_ukgc: Scene & {
                contents: {
                    autoplay_radio_4?: ButtonElement
                    autoplay_radio_3?: ButtonElement
                    autoplay_radio_2?: ButtonElement
                    autoplay_radio_1?: ButtonElement
                    close?: ButtonElement
                    autoplay_nonUK_bg?: Sprite
                    autoplay_radio_4_label?: Text
                    autoplay_radio_3_label?: Text
                    autoplay_radio_2_label?: Text
                    autoplay_radio_1_label?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             betsetting: Scene & {
                contents: {
                    close?: ButtonElement
                    bet_amount_slider_down?: ButtonElement
                    bet_amount_slider_up?: ButtonElement
                    bet_amount_slider_handle?: Sprite
                    bet_amount_slider_fill?: Sprite
                    bet_amount_slider_track?: Sprite
                    line_slider_down?: ButtonElement
                    line_slider_up?: ButtonElement
                    line_slider_handle?: Sprite
                    line_slider_fill?: Sprite
                    line_slider_track?: Sprite
                    bet_settings_background?: Sprite
                    detection_area?: Sprite
                    bet_amount_slider_amount?: Text
                    bet_amount_slider_label?: Text
                    line_slider_label?: Text
                    total_stake?: Text
                    total_bet?: Text
                    lines?: Text
                    bet_settings?: Text
                    bet_per_line?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             general: Scene & {
                contents: {
                    close?: ButtonElement
                    help?: ButtonElement
                    ags_deposit?: ButtonElement
                    ags_home?: ButtonElement
                    ags_accounts?: ButtonElement
                    sound_toggle_off?: ButtonElement
                    sound_toggle_on?: ButtonElement
                    sound_toggle_loading?: Sprite
                    left?: SmartShape
                    center?: SmartShape
                    right?: SmartShape
                    cover?: Sprite
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             paytable: Scene & {
                contents: {
                    previous?: ButtonElement
                    next?: ButtonElement
                    close?: ButtonElement
                    page_offset?: ButtonElement
                    page_centre?: ButtonElement
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
        };
    };
    public MuteButton: Layers & {
        scene: {
             default: Scene & {
                contents: {
                    sound_toggle_off?: ButtonElement
                    sound_toggle_loading?: Sprite
                    sound_toggle_on?: ButtonElement
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    sound_toggle_off?: ButtonElement
                    sound_toggle_loading?: Sprite
                    sound_toggle_on?: ButtonElement
                };
            };
        };
    };
    public PaytableBackground: Layers & {
        scene: {
             base: Scene & {
                contents: {
                    background_ls?: Sprite
                    background_pt?: Sprite
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    background_ls?: Sprite
                    background_pt?: Sprite
                };
            };
        };
    };
    public PaytableContent: Layers & {
        scene: {
             page_1: Scene & {
                contents: {
                    paytable_landscape?: Sprite
                    paytable_portrait?: Sprite
                    paytable_title_5?: Text
                    malfunction?: Text
                    paytable_multiplier_msg?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    paytable_landscape?: Sprite
                    paytable_portrait?: Sprite
                    paytable_title_5?: Text
                    malfunction?: Text
                    paytable_multiplier_msg?: Text
                    paylines?: Sprite
                    paylines_3x3?: Sprite
                    paytable_title_4?: Text
                    paytable_title_1?: Text
                    page_1_text_1?: Text
                    page_1_text_2?: Text
                    page_1_text_3?: Text
                    page_1_text_4?: Text
                    paytable_title_3?: Text
                    page_3_text_1?: Text
                    page_3_text_2?: Text
                    page_3_text_3?: Text
                    page_3_text_4?: Text
                    info_bg?: Sprite
                    paytable_title_6?: Text
                    pg6in1?: Text
                    pg6in3?: Text
                    game_rules?: Text
                };
            };
             page_2: Scene & {
                contents: {
                    paylines?: Sprite
                    paylines_3x3?: Sprite
                    paytable_title_4?: Text
                    malfunction?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             page_3: Scene & {
                contents: {
                    paytable_title_1?: Text
                    malfunction?: Text
                    page_1_text_1?: Text
                    page_1_text_2?: Text
                    page_1_text_3?: Text
                    page_1_text_4?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             page_4: Scene & {
                contents: {
                    paytable_title_3?: Text
                    malfunction?: Text
                    page_3_text_1?: Text
                    page_3_text_2?: Text
                    page_3_text_3?: Text
                    page_3_text_4?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             page_5: Scene & {
                contents: {
                    info_bg?: Sprite
                    paytable_title_6?: Text
                    pg6in1?: Text
                    pg6in3?: Text
                    game_rules?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
        };
    };
    public Prompts: Layers & {
        scene: {
             error: Scene & {
                contents: {
                    continue?: ButtonElement
                    modal_bg?: Sprite
                    background?: SmartShape
                    body?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    continue?: ButtonElement
                    modal_bg?: Sprite
                    background?: SmartShape
                    body?: Text
                    no?: ButtonElement
                };
            };
             info: Scene & {
                contents: {
                    continue?: ButtonElement
                    modal_bg?: Sprite
                    background?: SmartShape
                    body?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             yes_no: Scene & {
                contents: {
                    no?: ButtonElement
                    continue?: ButtonElement
                    modal_bg?: Sprite
                    background?: SmartShape
                    body?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
        };
    };
    public Rays: Layers & {
        scene: {
             default: Scene & {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    rays?: Sprite
                };
            };
             bigwin: Scene & {
                contents: {
                    rays?: Sprite
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
        };
    };
    public SettingsMenuTemplate: Layers & {
        scene: {
             settings: Scene & {
                contents: {
                    close?: ButtonElement
                    generic_button?: ButtonElement
                    settings_menu_background?: Sprite
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    close?: ButtonElement
                    generic_button?: ButtonElement
                    settings_menu_background?: Sprite
                };
            };
        };
    };
    public Skip: Layers & {
        scene: {
             skip: Scene & {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
        };
    };
    public SmartButton: Layers & {
        scene: {
             auto: Scene & {
                contents: {
                    autoplay_stop_button?: ButtonElement
                    spin?: ButtonElement
                    autoplay_count?: Text
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    autoplay_stop_button?: ButtonElement
                    spin?: ButtonElement
                    autoplay_count?: Text
                    autoplay?: ButtonElement
                    skipArea?: SmartShape
                };
            };
             base: Scene & {
                contents: {
                    autoplay?: ButtonElement
                    spin?: ButtonElement
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             base_noauto: Scene & {
                contents: {
                    spin?: ButtonElement
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             freespins: Scene & {
                contents: {
                    autoplay?: ButtonElement
                    spin?: ButtonElement
                    skipArea?: SmartShape
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             freespins_noauto: Scene & {
                contents: {
                    spin?: ButtonElement
                    skipArea?: SmartShape
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             skip: Scene & {
                contents: {
                    autoplay?: ButtonElement
                    spin?: ButtonElement
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
             skip_noauto: Scene & {
                contents: {
                    spin?: ButtonElement
                    skipArea?: SmartShape
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
        };
    };
    public StepperLineDisplay: Layers & {
        scene: {
             default: Scene & {
                contents: {
                    line0_dots?: Sprite
                    line0_segment?: Sprite
                    line1_dots?: Sprite
                    line1_segment?: Sprite
                    line2_dots?: Sprite
                    line2_segment?: Sprite
                    line3_dots?: Sprite
                    line3_segment?: Sprite
                    line4_dots?: Sprite
                    line4_segment?: Sprite
                    line5_dots?: Sprite
                    line5_segment?: Sprite
                    line6_dots?: Sprite
                    line6_segment?: Sprite
                    line7_dots?: Sprite
                    line7_segment?: Sprite
                    line8_dots?: Sprite
                    line8_segment?: Sprite
                    dark_red_dots?: Sprite
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                    line0_dots?: Sprite
                    line0_segment?: Sprite
                    line1_dots?: Sprite
                    line1_segment?: Sprite
                    line2_dots?: Sprite
                    line2_segment?: Sprite
                    line3_dots?: Sprite
                    line3_segment?: Sprite
                    line4_dots?: Sprite
                    line4_segment?: Sprite
                    line5_dots?: Sprite
                    line5_segment?: Sprite
                    line6_dots?: Sprite
                    line6_segment?: Sprite
                    line7_dots?: Sprite
                    line7_segment?: Sprite
                    line8_dots?: Sprite
                    line8_segment?: Sprite
                    dark_red_dots?: Sprite
                };
            };
        };
    };
    public SymbolAnimations: Layers & {
        scene: {
             default: Scene & {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
            active: {
                contents: {
                    positions: {
                        [key: string]: DualPosition
                    };
                };
            };
        };
    };
}

export enum LayerNames {
    Alerts = "alerts",
    Background = "background",
    Banners = "banners",
    BetBar = "betbar",
    BigWinEmitter = "bigwinemitter",
    BigWinFirework = "bigwinfirework",
    BigWinText = "bigwintext",
    CelebrationContent = "celebrationcontent",
    CelebrationForeground = "celebrationforeground",
    Footer = "footer",
    HamburgerMenu = "hamburgermenu",
    Header = "header",
    Jackpots = "jackpots",
    MatrixBackground = "matrixbackground",
    MatrixContent = "matrixcontent",
    MatrixForeground = "matrixforeground",
    MenusContent = "menuscontent",
    MuteButton = "mutebutton",
    PaytableBackground = "paytablebackground",
    PaytableContent = "paytablecontent",
    Prompts = "prompts",
    Rays = "rays",
    SettingsMenuTemplate = "settingsmenutemplate",
    Skip = "skip",
    SmartButton = "smartbutton",
    StepperLineDisplay = "stepperlinedisplay",
    SymbolAnimations = "symbolanimations"
}

export const gameLayers = new GameLayers();
export const assetworksData = {gameLayers, LayerNames, SoundNames};
